/* ================================================================
   LUSINE – SCRIPT FINAL (SILENCIEUX & HYBRIDE)
   Gestion variant, stock, oversell, low stock, lead time
   Supporte : Page Produit (Texte) & Quick View (Icones)
   Ignore silencieusement les collections (pas d'erreurs rouges)
   ================================================================= */

// Mettre à TRUE uniquement pour debugger (laisser false en prod)
const DEBUG_MODE = false; 

function log(msg, type = "info") {
  if (!DEBUG_MODE) return;
  if (type === "error") console.error(`[StockScript] ❌ ${msg}`);
else if (type === "warn") console.warn(`[StockScript] ⚠️ ${msg}`);
  else console.log(`[StockScript] ℹ️ ${msg}`);
}

/* ---------------------------------------------------------------
   HELPER : Récupérer le variant actuel
   --------------------------------------------------------------- */
function getCurrentVariant(context) {
// 1. Cas "Product Variants" component
  if (context.currentVariant) return context.currentVariant;

  // 2. Identifier le formulaire
  let form = null;
  if (context.tagName === "FORM") {
form = context;
}   else {
    const id = context.dataset.id;
if (id) {
    form = document.querySelector(`#product-form-${id}`);
    } else {
      form = context.closest("form");
  }
}

  // 3. Si on a le formulaire, on cherche l'ID dans l'input hidden
  if (form) {
    const input = form.querySelector('input[name="id"]');
    if (input && input.value) {
return { id: input.value, inventory_quantity: 0, inventory_policy: 'deny' }; 
}
  }

  return null;
}

/* ---------------------------------------------------------------
   1. UTILITAIRE : Lire les données (Retourne NULL si absentes)
   --------------------------------------------------------------- */
function computeVariantStockData(variant) {
  // Récupération de la div cachée générée par Liquid
  const dataEl = document.querySelector(`#variant-data-${variant.id}`);
  
  // 🛑 CORRECTION ICI : Si pas de données, on retourne null tout de suite
  // Cela évite les erreurs sur les pages de collection
  if (!dataEl) {
     return null; 
  }

  let availableQty = parseInt(variant.inventory_quantity || 0, 10);
  if (dataEl.dataset.stockQty) availableQty = parseInt(dataEl.dataset.stockQty || "0", 10);
  
    let leadTime = dataEl.dataset.leadTime || "";
  let availabilityDate = dataEl.dataset.availabilityDate || "";
  let soldOutFlag = dataEl.dataset.soldOut === "true";
  let totalStock = parseInt(dataEl.dataset.totalStock || "0", 10);
  let displayLeadTime = dataEl.dataset.displayLeadTime === "true";
    let lowStock = dataEl.dataset.lowStock === "true";
  let lowStockQty = parseInt(dataEl.dataset.lowStockQuantity || "0", 10);

  const hasFutureInfo = (leadTime && leadTime !== "0") || (availabilityDate && availabilityDate !== "") || totalStock > 0;
        const canOversell = variant.inventory_policy === "continue" || (!soldOutFlag && hasFutureInfo); 

  return { availableQty, leadTime, availabilityDate, soldOutFlag, displayLeadTime, totalStock, canOversell, lowStock, lowStockQty };
}

/* ---------------------------------------------------------------
   2. UPDATE ADD TO CART BUTTON (VERSION HYBRIDE)
   --------------------------------------------------------------- */
function updateAddToCartButton(context, variant) {
  let productForm = null;
  if (context.tagName === 'FORM') productForm = context;
  else {
    const id = context.dataset.id;
    if(id) productForm = document.querySelector(`#product-form-${id}`);
  }
  
  if (!productForm) return;

  // 🕵️ DETECTION Quick View
  const isQuickView = productForm.closest('product-quick-view') !== null || productForm.closest('.product-quick-view') !== null;

  const stockData = computeVariantStockData(variant);

  // 🛑 Si pas de données (ex: page collection), on ne touche pas au bouton
  if (!stockData) return;

  const { availableQty, soldOutFlag, leadTime, availabilityDate, displayLeadTime, totalStock } = stockData;

  const btn = productForm.querySelector("[data-js-product-add-to-cart], button[name='add'], button[type='submit']");
  const txt = productForm.querySelector("[data-js-product-add-to-cart-text], span[data-add-to-cart-text]");
  
  if (!btn) return;

  const lang = document.documentElement.lang.includes("en") ? "en" : "fr";
  const i18n = {
    fr: { add: "Ajouter au panier", sold: "Épuisé", soon: "bientôt", lead: "semaines" },
    en: { add: "Add to cart", sold: "Sold out", soon: "soon", lead: "weeks" }
  };
  
// --- ICONES SVG ---
  const icons = {
    add: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align: sub;"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>`,
    preorder: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align: sub;"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>`,
    sold: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align: sub;"><circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line></svg>`
  };
  
  let buttonContent = "";
  let mode = "stock";

/* CAS 1: STOCK DISPONIBLE */
  if (availableQty > 0) {
    mode = "stock";
    buttonContent = isQuickView ? icons.add : i18n[lang].add;
  } 

  /* CAS 2: PRÉCOMMANDE */
  else if (!soldOutFlag && (leadTime || availabilityDate || totalStock > 0)) {
    mode = "preorder";
    if (isQuickView) {
buttonContent = icons.preorder;
    }     else {
      if (!displayLeadTime && availabilityDate) {
buttonContent = lang === "fr" ? `Précommander - disponible le ${availabilityDate}` : `Pre-order - available on ${availabilityDate}`;
}       else if (displayLeadTime) {
buttonContent = lang === "fr" ? `Précommander - DÉLAI DE ${leadTime} ${i18n.fr.lead}` : `Pre-order – lead time ${leadTime} ${i18n.en.lead}`;
}       else {
buttonContent = lang === "fr" ? `Précommander - ${i18n.fr.soon}` : `Pre-order – ${i18n.en.soon}`;
    }
  } 
} 
  
  /* CAS 3: ÉPUISÉ */
  else {
    mode = "soldout";
    buttonContent = isQuickView ? icons.sold : i18n[lang].sold;
  }

  if (txt) txt.innerHTML = buttonContent;
  else btn.innerHTML = buttonContent;

  btn.disabled = mode === "soldout";
  productForm.classList.toggle("disabled-cart", mode === "soldout");
}

/* ---------------------------------------------------------------
   3. LOGIQUE QUANTITÉ
   --------------------------------------------------------------- */
function setupQuantityListeners(context) {
  let productForm = null;
  if (context.tagName === 'FORM') productForm = context;
  else {
    const id = context.dataset.id;
    if(id) productForm = document.querySelector(`#product-form-${id}`);
  }

  if (!productForm) return;

  const qtySelector = productForm.querySelector(".quantity-selector-holder, .product-form__quantity");
  if (!qtySelector) return;

  const qtyInput = qtySelector.querySelector("input");
  const minusBtn = qtySelector.querySelector(".qty-minus, [name='minus']");
  const plusBtn = qtySelector.querySelector(".qty-plus, [name='plus']");

  let msgBox = productForm.querySelector(".stock-warning-message");
  if (!msgBox) {
    msgBox = document.createElement("div");
    msgBox.className = "stock-warning-message";
    msgBox.style.marginTop = "8px";
    msgBox.style.fontSize = "14px";
    productForm.appendChild(msgBox);
  }

  const updateMessages = () => {
    const variant = getCurrentVariant(context); 
    if (!variant) return;

    const stockData = computeVariantStockData(variant);
// 🛑 Si pas de données, on arrête là
    if (!stockData) return;

        /* ⚖️ LA RÈGLE (FnF, 2026-09-22) : c'est next_inventory_arrival qui dirige.
       - sold_out DÉCOCHÉ  ⇒ vente / prévente : on ne rabat JAMAIS la quantité,
                             on affiche seulement ce qu'il reste et le délai.
       - sold_out COCHÉ    ⇒ le plafond est total_quantity_available, le MÊME
                             nombre que l'attribut max écrit par le Liquid.

       ⛔ NE PAS rebrancher canOversell ici. Cette garde est débranchée :
          variant.inventory_policy n'existe dans aucun des deux chemins d'appel
          (fabriqué en dur à 'deny' sans variante, absent de product.variants | json).

       ⛔ NE PAS rabattre sur availableQty : c'est inventory_quantity, le stock
          SHOPIFY. Le Liquid, lui, écrit total_quantity_available dans max.
          Deux nombres sous le même nom — mesuré sur LH1797 le 2026-09-22 :
          le champ plafonnait à 20 (stock Shopify) alors que max affichait 31. */
    const { availableQty, soldOutFlag, totalStock, lowStock, lowStockQty, leadTime } = stockData;

    /* 🔑 Le Liquid a écrit max pour la PREMIÈRE variante seulement
       (product.selected_or_first_available_variant) et ne le recalcule jamais.
       C'est ici qu'il suit la variante réellement choisie — sinon le plafond de
       la variante par défaut mord sur toutes les autres, en silence.
       (Chaise Sinatra : LH11890 par défaut, LH1797 en second.) */
    const defaultMax = parseInt(qtyInput.dataset.defaultMax || "999", 10) || 999;
    qtyInput.setAttribute("max", soldOutFlag ? totalStock : defaultMax);

    const qty = parseInt(qtyInput.value || "1", 10);
    msgBox.innerHTML = "";

    if (lowStock && availableQty > 0 && availableQty <= lowStockQty) {
      msgBox.innerHTML += `<p style="color:#d46b00;">Bas inventaire! Seulement ${availableQty} restants.</p>`;
    }

        // « Sold out » coché : le seul cas où on plafonne.
    // On NOMME le motif — sans « Sold out », le client lit un plafond sans savoir
    // pourquoi, et 31 disponibles ressemble à un bogue plutôt qu'à une fin de série.
    if (soldOutFlag) {
      if (qty > totalStock) {
        qtyInput.value = totalStock;
        const isEn = document.documentElement.lang.includes("en");
        msgBox.innerHTML = isEn
          ? `<p style="color:#b80000;">Sold out — quantity available: ${totalStock}.</p>`
          : `<p style="color:#b80000;">Sold out — quantité(s) disponible(s) : ${totalStock}.</p>`;
      }
      return;
    }

    // Vente / prévente : on laisse commander au-delà du stock, mais on le DIT.
    // (le availableQty != 0 d'avant avalait justement le cas « il n'en reste plus »)
    if (qty > availableQty) {
      const extra = qty - availableQty;
      const delay = leadTime || "2 à 4";
      msgBox.innerHTML = `<p style="color:#e68a00;">${availableQty} en inventaire et ${extra} disponible(s) avec <strong>délai estimé de ${delay} semaines</strong></p>`;
      return;
    }
  };

  if (!qtySelector.hasListenersInstalled) {
    if (minusBtn) minusBtn.addEventListener("click", () => setTimeout(updateMessages, 20));
    if (plusBtn) plusBtn.addEventListener("click", () => setTimeout(updateMessages, 20));
    if (qtyInput) qtyInput.addEventListener("input", updateMessages);
    qtySelector.hasListenersInstalled = true;
  }

  updateMessages();
}

/* ---------------------------------------------------------------
   4. INITIALISATION GLOBALE
   --------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", () => {
  log("Script chargé. Recherche des formulaires...");

  const handledForms = new Set(); 

  // A. Produits avec variantes
  const variantSelectors = document.querySelectorAll("product-variants");
  variantSelectors.forEach((pv) => {
    const initialVariant = getCurrentVariant(pv);
    if (initialVariant) {
      updateAddToCartButton(pv, initialVariant);
            setupQuantityListeners(pv);

      const form = pv.closest('form') || document.querySelector(`#product-form-${pv.dataset.id}`);
      if(form) handledForms.add(form);
    }

    pv.addEventListener("VARIANT_CHANGE", () => {
      if (pv.currentVariant) {
        updateAddToCartButton(pv, pv.currentVariant);
                setupQuantityListeners(pv); 
      }
    });
  });

  // B. Produits SANS variantes (Page, Quick View ou Collection)
  const allForms = document.querySelectorAll('form');

  allForms.forEach(form => {
    if (handledForms.has(form)) return;
const idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;
    const isCartForm = form.action.includes('/cart/add') || form.querySelector('[name="add"]');

    if (isCartForm) {
      const simpleVariant = getCurrentVariant(form);
      if (simpleVariant) {
        updateAddToCartButton(form, simpleVariant);
                setupQuantityListeners(form);
      }
    }
  });
});